/**
 * @desc 列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.firstTrialOrderDetail.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/firstTrialOrderDetail/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
